/* eslint-disable max-len */
function renderStars(
  rating,
  containerSelector,
  fullStarPath,
  emptyStarPath,
  fillColor,
  strokeColor,
) {
  const totalStars = 5;
  const fullStars = Math.floor(rating);
  const partialStarValue = rating - fullStars;
  const emptyStars = totalStars - fullStars - (partialStarValue > 0 ? 1 : 0);

  const starsContainer = document.querySelector(containerSelector);
  if (!starsContainer) {
    console.error(`Container with selector '${containerSelector}' not found.`);
    return;
  }
  starsContainer.innerHTML = "";

  for (let i = 0; i < fullStars; i++) {
    const fullStarSVG = `
          <svg class="star-success" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="${fullStarPath}" fill="${fillColor}"/>
          </svg>
      `;
    starsContainer.insertAdjacentHTML("beforeend", fullStarSVG);
  }

  if (partialStarValue > 0) {
    const percentageFill = partialStarValue * 100;
    const gradientId = `partialFillGradient-${containerSelector.replace(/\W/g, "_")}-${Math.random().toString(36).substring(7)}`;

    const partialStarSVG = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="${gradientId}" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="${percentageFill}%" stop-color="${fillColor}"/>
                <stop offset="${percentageFill}%" stop-color="transparent"/>
              </linearGradient>
            </defs>
            <path d="${emptyStarPath}" stroke="${strokeColor}" stroke-width="0.838235" stroke-linejoin="round" fill="none"/>
            <path d="${fullStarPath}" fill="url(#${gradientId})"/>
          </svg>
      `;
    starsContainer.insertAdjacentHTML("beforeend", partialStarSVG);
  }

  for (let i = 0; i < emptyStars; i++) {
    const emptyStarSVG = `
          <svg class="star-empty" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="${emptyStarPath}" stroke="${strokeColor}" stroke-width="0.838235" stroke-linejoin="round"/>
          </svg>
      `;
    starsContainer.insertAdjacentHTML("beforeend", emptyStarSVG);
  }
}

const heroFullStarPath = "M9.57949 2.25964C9.75163 1.91085 10.249 1.91085 10.4211 2.25964L12.6495 6.77474C12.7178 6.91325 12.8499 7.00925 13.0028 7.03146L17.9855 7.75549C18.3704 7.81142 18.5241 8.28444 18.2456 8.55593L14.6401 12.0704C14.5295 12.1783 14.479 12.3336 14.5051 12.4858L15.3563 17.4484C15.422 17.8318 15.0196 18.1241 14.6754 17.9431L10.2187 15.6001C10.082 15.5282 9.91864 15.5282 9.78193 15.6001L5.32526 17.9431C4.98098 18.1241 4.57861 17.8318 4.64436 17.4484L5.49551 12.4858C5.52162 12.3336 5.47115 12.1783 5.36055 12.0704L1.75502 8.55593C1.4765 8.28444 1.63019 7.81142 2.0151 7.75549L6.99781 7.03146C7.15066 7.00925 7.28279 6.91325 7.35115 6.77474L9.57949 2.25964Z";
const heroEmptyStarPath = "M10.0278 2.42383C10.0326 2.42668 10.039 2.43226 10.0454 2.44531L12.2739 6.95996C12.4033 7.22217 12.6535 7.40424 12.9429 7.44629L17.9253 8.16992C17.9398 8.17203 17.9465 8.17702 17.9507 8.18066C17.9561 8.18542 17.9618 8.19337 17.9653 8.2041C17.9689 8.21503 17.9689 8.22532 17.9673 8.23242C17.966 8.23782 17.9631 8.24566 17.9526 8.25586L14.3472 11.7705C14.138 11.9746 14.0429 12.2686 14.0923 12.5566L14.9429 17.5195C14.9453 17.534 14.9431 17.5418 14.9409 17.5469C14.938 17.5535 14.9326 17.5616 14.9233 17.5684C14.914 17.5751 14.9042 17.5784 14.897 17.5791C14.8915 17.5796 14.8833 17.5789 14.8706 17.5723L10.4136 15.2295C10.1548 15.0934 9.84524 15.0934 9.58643 15.2295L5.13037 17.5723C5.11726 17.5792 5.10855 17.5796 5.10303 17.5791C5.09586 17.5784 5.08676 17.5749 5.07764 17.5684C5.06834 17.5616 5.06197 17.5536 5.05908 17.5469C5.05692 17.5418 5.05474 17.5338 5.05713 17.5195L5.90869 12.5566C5.9581 12.2685 5.8622 11.9746 5.65283 11.7705L2.04736 8.25586C2.03688 8.24562 2.03394 8.23781 2.03271 8.23242C2.03112 8.22532 2.03112 8.21503 2.03467 8.2041C2.03818 8.19341 2.04394 8.18546 2.04932 8.18066C2.05348 8.177 2.06103 8.17205 2.07568 8.16992L7.05811 7.44629C7.34746 7.40424 7.59765 7.22216 7.72705 6.95996L9.95557 2.44531C9.96212 2.43203 9.96838 2.42666 9.97314 2.42383C9.97941 2.42012 9.98902 2.41699 10.0005 2.41699C10.0119 2.41702 10.0216 2.42013 10.0278 2.42383Z";

const currentRatingElement = document.querySelector(".rating-total");
if (currentRatingElement) {
  const currentRating = parseFloat(currentRatingElement.textContent);
  renderStars(
    currentRating,
    ".rating-stars-display",
    heroFullStarPath,
    heroEmptyStarPath,
    "#F29130",
    "#464C5C"
  );
}

const footerFullStarPath = "M9.579 2.26159C9.75114 1.9128 10.2485 1.9128 10.4206 2.26159L12.649 6.7767C12.7173 6.9152 12.8495 7.0112 13.0023 7.03341L17.985 7.75744C18.3699 7.81337 18.5236 8.28639 18.2451 8.55788L14.6396 12.0724C14.529 12.1802 14.4785 12.3355 14.5046 12.4878L15.3558 17.4504C15.4215 17.8337 15.0191 18.126 14.6749 17.9451L10.2182 15.602C10.0815 15.5302 9.91815 15.5302 9.78144 15.602L5.32477 17.9451C4.98049 18.126 4.57812 17.8337 4.64387 17.4504L5.49502 12.4878C5.52113 12.3355 5.47066 12.1802 5.36006 12.0724L1.75453 8.55788C1.47601 8.28639 1.6297 7.81337 2.01461 7.75744L6.99733 7.03341C7.15017 7.0112 7.28231 6.9152 7.35066 6.7767L9.579 2.26159Z";
const footerEmptyStarPath = "M10.0283 2.4248C10.0333 2.42787 10.0404 2.43316 10.0469 2.44629L12.2744 6.96094C12.4036 7.2226 12.6536 7.40433 12.9424 7.44629L17.9248 8.16992C17.9397 8.17209 17.9467 8.17776 17.9512 8.18164C17.9569 8.18668 17.9631 8.19483 17.9668 8.20605C17.9703 8.2171 17.9704 8.227 17.9688 8.23438C17.9675 8.24008 17.9647 8.24834 17.9541 8.25879L14.3486 11.7734C14.1397 11.9771 14.0444 12.271 14.0938 12.5586L14.9443 17.5205C14.9469 17.5355 14.9447 17.5444 14.9424 17.5498C14.9394 17.5567 14.9332 17.5645 14.9238 17.5713C14.9143 17.5782 14.9041 17.5823 14.8965 17.583C14.8907 17.5835 14.882 17.5829 14.8691 17.5762L10.4121 15.2324C10.1539 15.0968 9.84508 15.0967 9.58691 15.2324L5.13086 17.5762C5.11743 17.5832 5.10841 17.5836 5.10254 17.583C5.09496 17.5823 5.08568 17.5782 5.07617 17.5713C5.06677 17.5645 5.06068 17.5567 5.05762 17.5498C5.05528 17.5444 5.05212 17.5355 5.05469 17.5205L5.90625 12.5586C5.95558 12.271 5.86031 11.9771 5.65137 11.7734L2.0459 8.25879C2.03511 8.24824 2.03156 8.24011 2.03027 8.23438C2.02869 8.22705 2.02875 8.21697 2.03223 8.20605C2.03582 8.19501 2.04221 8.1867 2.04785 8.18164C2.05225 8.17778 2.05943 8.17212 2.07422 8.16992L7.05762 7.44629C7.34625 7.40425 7.59552 7.22251 7.72461 6.96094L9.95312 2.44629C9.95972 2.43293 9.96664 2.42784 9.97168 2.4248C9.97824 2.42092 9.98819 2.41699 10 2.41699C10.0117 2.41702 10.0218 2.42094 10.0283 2.4248Z";

const mobileRating = 4.8;

renderStars(
  mobileRating,
  ".rating-weblium-stars-displa-mobile",
  footerFullStarPath,
  footerEmptyStarPath,
  "white",
  "white"
);
